import { render } from "./JobFair.vue?vue&type=template&id=3156de5d"
import script from "./JobFair.vue?vue&type=script&lang=js"
export * from "./JobFair.vue?vue&type=script&lang=js"

import "./JobFair.vue?vue&type=style&index=0&id=3156de5d&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__